import {
  equals,
  filter,
  forEach,
  head,
  isEmpty,
  join,
  keys,
  length,
  pathOr,
} from 'ramda';

import { _cf } from 'src/features/DLish/SBA/print_utilities';
import { isOwnerShareInvalid } from 'src/utilities/business';
import {
  filterDocument
} from 'src/utilities/document';
import { isNotEmpty, isEmptyOrInvalid, returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';

export const hasSubmittedInputStar = (business: any, minOwnerSharePercentage?: number) => {
  const owners = pathOr([], ['owners'], business);
  const minSharePercentage = returnIsNotEmptyOrTrue(
    minOwnerSharePercentage,
    minOwnerSharePercentage,
    50
  )
  let missingInfo = getMissingStarBusinessInfo(business);
  const missingOwnerInfo = getOwnerMissingInfo(head(owners), business);
  if (isNotEmpty(missingOwnerInfo)) {
    missingInfo.push(
      isNotEmpty(owners)
        ? `At Least one Owner's ${join(', ', missingOwnerInfo)}`
        : "At Least one Owner's name, SSN, share percentage, date of birth, and address"
    );
  }
  const share = pathOr('', ['share'], owners[0]);
  if (equals(length(owners), 1) && share && isOwnerShareInvalid(owners, minSharePercentage)) {
    missingInfo.push(
      `The total owner's share percentage must be greater than ${minSharePercentage} and less than 100`
      );
  }
  return missingInfo;
};

export const hasSubmittedInput = (business: any) => {
  return  getMissingBusinessInfo(business);
};

const getOwnerMissingInfo = (owner: any, business: any) => {
  const name = pathOr('', ['name'], owner);
  const share = pathOr('', ['share'], owner);
  const ssn = pathOr('', ['tin_ein_ssn'], owner);
  const dob = pathOr('', ['metadata', 'dob1'], business);
  const address = pathOr('', ['address'], owner);
  let requiredInfo = {
    name: name,
    SSN: ssn,
    'share percentage': share,
    'date of birth': dob,
    address: address,
  };
  let missingInfo: string[] = [];
  forEach((key) => {
    if (isEmptyOrInvalid(requiredInfo[key])) {
      missingInfo.push(key);
    }
  }, Object.keys(requiredInfo));
  return missingInfo;
};

const getMissingBusinessInfo = (business: any) => {
  const businessName = pathOr('', ['business_name'], business);
  const address = pathOr('', ['address'], business);
  const startDate = pathOr('', ['metadata', 'time_in_business'], business);

  let requiredInfo = {
         'Business Name': businessName,
    'Business address': address,
    'Business start date': startDate,

  };
  const missingInfo: string[] = filter((key) => isEmptyOrInvalid(requiredInfo[key]), keys(requiredInfo));
  return missingInfo;
};

const getMissingStarBusinessInfo = (business: any) => {
  const businessName = pathOr('', ['business_name'], business);
  const business_entity = pathOr('', ['metadata', 'legal_entity'], business)
  const startDate = pathOr('', ['metadata', 'time_in_business'], business);
  const incorpratedAddress = pathOr('', ['metadata', 'incorprated_address'], business);
  const monthlySales = pathOr('', ['metadata', 'monthly_sales'], business);
  const fundingAmount = pathOr('', ['metadata', 'funding_amount'], business);
  const cashoutPurpose = pathOr('', ['metadata', 'lendsmart_sh/cashout_purpose'], business);
  const industryType = pathOr('', ['metadata', 'industry_type'], business);

  let requiredInfo = {
    'Business Name': businessName,
    'Business Entity': business_entity,
    'Business start date': startDate,
    'Business Incorporated State': incorpratedAddress,
    'Business monthly sale': monthlySales,
    'Funding Amount': fundingAmount,
    'Use of the Funding': cashoutPurpose,
    'Industry type': industryType,
  };
  const missingInfo: string[] = filter((key) => isEmptyOrInvalid(requiredInfo[key]), keys(requiredInfo));
  return missingInfo;
};

export const hasDocuments = (documentPointers: any, catgory: string) => {
  let missingDocs = [];
  if (isNotEmpty(documentPointers)) {
    if (
      isEmpty(
        filterDocument(documentPointers, catgory)
      )
    ) {
      missingDocs.push(catgory);
    }
  } else {
    missingDocs.push(catgory);
  }

  return missingDocs;
};

